module.exports = __webpack_public_path__ + "static/media/undraw_visual_data_big.20c354e1.svg";